import { adminHttpClient } from '../commons/adminHttpClient'

export type CoverageProviderByMonthResponse = {
  id: string
  name: string
  providerStartDate: string
}

export const getCoverageProviderByMonth = (
  date: string,
  familyMemberId?: string,
): Promise<CoverageProviderByMonthResponse> => {
  return adminHttpClient.get(`/Expenses/CoverageProviderByMonth/${date}?familyMemberId=${familyMemberId ?? ''}`)
}
